import React from 'react';
import {
  DocumentNodeModal,
  ImageNodeModal,
  NoteNodeModal,
  ProtocolNodeModal,
  QuestionnaireNodeModal,
  RisSearchModal,
  SurfaceNodeModal,
  TextNodeModal,
  TextSnippetNodeModal,
  BackgroundNodeModal,
  QuestionnaireNodeFormModal,
} from './style';
import useSurfaceNodeModalsContext from 'routes/surface/hooks/use-surface-node-modals-context';

export interface SurfaceNodeModalsProps {}

const defaultProps = {};

function SurfaceNodeModals() {
  const { modalRefs, onModalHide } = useSurfaceNodeModalsContext();

  return (
    <>
      <TextNodeModal ref={modalRefs.textNodeModal} onHide={onModalHide} />

      <NoteNodeModal ref={modalRefs.noteNodeModal} onHide={onModalHide} />
      <TextSnippetNodeModal
        ref={modalRefs.textSnippetNodeModal}
        onHide={onModalHide}
      />
      <DocumentNodeModal
        ref={modalRefs.documentNodeModal}
        onHide={onModalHide}
      />
      <SurfaceNodeModal ref={modalRefs.surfaceNodeModal} onHide={onModalHide} />
      <ProtocolNodeModal
        ref={modalRefs.protocolNodeModal}
        onHide={onModalHide}
      />
      <QuestionnaireNodeModal
        ref={modalRefs.questionnaireNodeModal}
        onHide={onModalHide}
      />

      <QuestionnaireNodeFormModal
        ref={modalRefs.formModal}
        onHide={onModalHide}
      />
      <ImageNodeModal ref={modalRefs.imageNodeModal} onHide={onModalHide} />
      <RisSearchModal ref={modalRefs.risSearchModal} onHide={onModalHide} />

      <BackgroundNodeModal
        ref={modalRefs.backgroundNodeModal}
        // ref={modalRefs.questionnaireFormModal}
        onHide={onModalHide}
      />
    </>
  );
}

SurfaceNodeModals.defaultProps = defaultProps;

export default SurfaceNodeModals;
